import { ExclamationCircleFilled } from '@ant-design/icons';
import { Button } from 'antd';
import React, { useEffect, useState } from 'react';

import ByModal from '@/components/ByModal';
import { useI18nContext } from '@/i18n/I18n';
import { clearFetchCache } from '@/services/request';
import { registerPermisson } from '@/services/user';

import { IpInfoType } from './type';

// IP检查，判断当前地区是否被支持
const IsLogin = ({
  onSuccess,
  onClose,
}: {
  onSuccess: () => void;
  onClose: () => void;
}) => {
  const [visible, setVisible] = useState(false);
  const [$t] = useI18nContext();
  const [ipInfo, setIpInfo] = useState<IpInfoType>({
    code: '',
    name_en: '',
    ip: '',
    is_visible: 1,
  });

  useEffect(() => {
    clearFetchCache('permission_v2');
    // 每次唤起组件都调用 permission_v2 接口判断当前IP是否可登录
    registerPermisson()
      .then((res) => {
        setIpInfo(res);
        if (!res.is_login) {
          setVisible(true);
          return;
        }
        // 可以使用时，同时执行成功回调 和 关闭回调
        onSuccess();
        onClose();
      })
      .catch(() => {
        setVisible(true);
      });

    return () => {
      setVisible(false);
    };
  }, []);

  const handleConfirm = () => {
    onClose();
  };

  const Title = () => {
    return (
      <>
        <ExclamationCircleFilled
          size={20}
          style={{ color: '#f7a600', marginRight: '8px' }}
        />
        {$t('noLogin.tit')}
      </>
    );
  };

  const ByFooter = () => {
    return (
      <div>
        <Button type="primary" onClick={handleConfirm}>
          {$t('Confirm')}
        </Button>
      </div>
    );
  };

  return (
    <ByModal
      visible={visible}
      title={<Title />}
      ByFooter={<ByFooter />}
      onCancel={() => handleConfirm()}
    >
      <div>{$t('noLogin.p').replace('{ip}', ipInfo?.ip || '')}</div>
    </ByModal>
  );
};
export default IsLogin;
